import { render, staticRenderFns } from "./RejectedTestimonialsListView.vue?vue&type=template&id=87fbcb3a&"
import script from "./RejectedTestimonialsListView.vue?vue&type=script&lang=js&"
export * from "./RejectedTestimonialsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports